export default function NotFound(){
    return (
        <div className="page text-primary text-center my-5 py-5">
            <h1 className="">404</h1>
            <h1 className="py-5 my-5">Page Not Found</h1>
        </div>
    )
}